import { Tab, TabList, TabPanel, Tabs } from "@mui/joy";
import React from "react";
import BuildingHeader from "../GenericComponents/BuildingHeader";
import ContactsListing from "./ContactsListing";
import ElevatorListing from "./ElevatorListing";
import InspectionReportsListing from "./InspectionReportsListing";
import NotesListing from "./NotesListing";
import TicketListing from "./TicketListing";
import ProposalInvoiceGrid from "./ProposalInvoiceGrid";
import { useRole } from "../Contexts/RoleContext";

interface BuildingPageProps {
	BuildingID: string;
}

export default function BuildingPage(props: BuildingPageProps) {
	const [tab, selectedTab] = React.useState(0);
	const { effectiveRole } = useRole();

	return (
		<>
			<BuildingHeader buildingId={props.BuildingID} />
			<Tabs defaultValue={tab} sx={{ overflowY: "hidden" }}>
				<TabList>
					<Tab>Tickets</Tab>
					{effectiveRole === "Admin" && (
						<>
					<Tab>Elevators</Tab>
					<Tab>Notes</Tab>
					<Tab>Contacts</Tab>
					<Tab>Inspection Reports</Tab>
					<Tab>Estimates</Tab>
					<Tab>Invoices</Tab>
					</>
					)}
				</TabList>
				<TabPanel sx={{ pt: 0, overflowY: "auto" }} value={0}>
					<TicketListing buildingId={props.BuildingID} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={1}>
					<ElevatorListing buildingId={props.BuildingID} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={2}>
					<NotesListing buildingId={props.BuildingID} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={3}>
					<ContactsListing buildingId={props.BuildingID} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={4}>
					<InspectionReportsListing buildingId={props.BuildingID} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={5}>
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={false} />
				</TabPanel>
				<TabPanel sx={{ p: 0, overflowY: "auto" }} value={6}>
					<ProposalInvoiceGrid buildingId={props.BuildingID} isInvoice={true} />
				</TabPanel>
			</Tabs>
		</>
	);
}
